import React from 'react'

interface AlertProps {
  type?: 'info' | 'success' | 'warning' | 'error'
  children: React.ReactNode
  className?: string
}

const Alert: React.FC<AlertProps> = ({
  type = 'info',
  children,
  className = ''
}) => {
  const typeStyles = {
    info: 'bg-blue-50 border-blue-400 text-blue-800',
    success: 'bg-green-50 border-green-400 text-green-800',
    warning: 'bg-yellow-50 border-yellow-400 text-yellow-800',
    error: 'bg-red-50 border-red-400 text-red-800'
  }

  const iconStyles = {
    info: '🔵',
    success: '✅',
    warning: '⚠️',
    error: '❌'
  }

  return (
    <div className={`border-l-4 px-4 pt-4 pb-2 mb-4 rounded ${typeStyles[type]} ${className}`}>
      <div className="flex items-start">
        <span className="text-xl mr-3">{iconStyles[type]}</span>
        <div className="flex-1">
          {children}
        </div>
      </div>
    </div>
  )
}

export default Alert